export enum TermsTabs {
  terms = 'terms',
  teleconsent = 'teleconsent',
  privacy = 'privacy',
}
